export default __webpack_public_path__ + "static/media/lottery-banners.85112d37.webp";